import DataLoader from "dataloader"
import { useQuery } from "@tanstack/react-query"
import { get } from "@/typed-client/get"
import type * as Api from "@/@client/api"

type EventsParams = Api.Input["/api/Calendar/GetMyEventsForDateRange"]
type EventsResult = Api.Output["/api/Calendar/GetMyEventsForDateRange"]

const loader = new DataLoader<string, EventsResult>(
  async (keys) => {
    const results = await Promise.all(
      keys.map((key) =>
        get(
          "/api/Calendar/GetMyEventsForDateRange",
          JSON.parse(key) as EventsParams,
          { headers: {} }
        )
      )
    )
    return results
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedCalendarEvents(params: EventsParams) {
  const key = JSON.stringify(params)
  return useQuery({
    queryKey: ["/api/Calendar/GetMyEventsForDateRange", params],
    queryFn: () => loader.load(key),
  })
}
